import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

function AdultContentCheckbox({ isChecked, handleDetailChange, parentalLocked }) {
  return (
    <Fragment>
      <input
        type="checkbox"
        name="isAdultContent"
        id="adult-content"
        className="checkbox is-spaced"
        checked={isChecked}
        onChange={() => handleDetailChange('isAdultContent', !isChecked)}
        disabled={parentalLocked}
      />

      <label htmlFor="adult-content" className="text-default">This item contains violence, nudity or sexual content</label>

      <Tooltip
        id="adult-content-tooltip"
        content={I18n.translate('tooltips.publisher.adult_content')}
        tooltipClassName="tooltip--big u-text-center"
        className="u-inline-block"
      >
        <Icon type={['fas', 'question-circle']} color="grey" className="ml-5" />
      </Tooltip>
    </Fragment>
  )
}

AdultContentCheckbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  handleDetailChange: PropTypes.func.isRequired,
  parentalLocked: PropTypes.bool.isRequired,
}

export default AdultContentCheckbox
